import store_fiche from '@/store/mods/consultations/fiche-consultations'
import store_consultation from '@/store/mods/consultations/consultations'
import sageFemmeApi from '@/modules/sage-femme/api'

export default {
    name: 'choix-fiche-consultation',
    props: {
        fiche_toggler: Number,
        info_consultation: { type: Object, default: () => ({}) },
        sections: { type: Array, default: () => [] },
        user_id: { type: Number, default: 0 },
        user_info: { type: Object, default: () => ({}) }
    },
    data() {
        return {
            groued_fiches_consultations: [], fiche_loading: false, fiche_empty: false,
            curr_fiche: 0, save_loading: false, is_confirm: false, confirmation: false,
            err_message: '', visible: false, contexte_loading: false, contexte_erreur: false,
            mode_tableau: false, selection: {}, contexte: {}, sections_debut: [],
            nom_fiche: '', fiches_disponibles: [], consultation_debut: {},
            sequence_demarrage: 0, resultat_incertain: false, conflit: false
        }
    },
    computed: {
        contexte_valide() {
            const contexte = this.mode_tableau ? this.contexte : this.info_consultation
            const sections = this.mode_tableau ? this.sections_debut : this.sections
            return Number(contexte.consultation_id) > 0 && Number(contexte.fiche_id) > 0 &&
                Number(contexte.evolution_id) > 0 && sections.length > 0
        },
        demarrage_disponible() {
            return this.contexte_valide && !this.contexte_loading && !this.contexte_erreur &&
                !this.resultat_incertain && !this.conflit && !this.save_loading
        }
    },
    watch: {
        fiche_toggler() { this.getGroupedFicheConnsultationByTypeConsultation() }
    },
    beforeDestroy() { this.sequence_demarrage++ },
    methods: {
        libelleFiche(nom) {
            return nom === 'Fiche patient' ? 'Fiche consultation modèle standard' : nom
        },
        async getGroupedFicheConnsultationByTypeConsultation() {
            this.fiche_loading = true
            try {
                const response = await store_fiche.getGroupedFicheConsultation()
                if (this._isDestroyed) return
                const groups = {}
                ;(Array.isArray(response) ? response : []).forEach(fiche => {
                    const nom = fiche.type_consultation || 'Fiche standard'
                    if (!groups[nom]) groups[nom] = { type_consultation: nom, fiches: [] }
                    groups[nom].fiches.push(fiche)
                })
                this.groued_fiches_consultations = Object.values(groups)
                this.fiche_empty = this.groued_fiches_consultations.length === 0
            } catch (error) {
                this.groued_fiches_consultations = []
                this.fiche_empty = true
                this.errorToast('Impossible de charger les fiches. Réessayez.')
            } finally { this.fiche_loading = false }
        },
        saveChoice() {
            this.$emit('emitRefreshFiche', { fiche_id: this.curr_fiche })
            this.$refs.brwse_fiche.click()
        },
        ouvrir_demarrage() {
            if (this.save_loading) return
            const consultation = this.$store.getters.consultationPatientEnCours || {}
            if (this.resultat_incertain && Number(this.selection.consultation_id) === Number(this.info_consultation.consultation_id)) {
                this.visible = true
                return
            }
            this.reinitialiser_demarrage()
            this.mode_tableau = false
            this.selection = {
                consultation_id: this.info_consultation.consultation_id,
                patient_id: consultation.patient_id,
                tarif_consultation_id: consultation.tarif_consultation_id,
                source_tableau_sage_femme: !!(this.$store.getters.selected_consultation_encours || {}).source_tableau_sage_femme
            }
            this.visible = true
        },
        ouvrir_demarrage_tableau(item) {
            if (this.save_loading || this.visible) return
            this.reinitialiser_demarrage()
            this.mode_tableau = true
            this.selection = Object.assign({}, item)
            this.visible = true
            return this.charger_contexte()
        },
        reinitialiser_demarrage() {
            this.sequence_demarrage++
            this.is_confirm = false
            this.confirmation = false
            this.err_message = ''
            this.resultat_incertain = false
            this.conflit = false
            this.contexte_erreur = false
            this.contexte = {}
            this.sections_debut = []
            this.fiches_disponibles = []
            this.nom_fiche = ''
            this.curr_fiche = 0
            this.consultation_debut = {}
        },
        fermer_demarrage(event) {
            if (this.save_loading) { if (event) event.preventDefault(); return }
            this.visible = false
            this.sequence_demarrage++
            this.confirmation = false
        },
        async lire_consultation_exacte() {
            const selected = this.selection
            if (!['consultation_id', 'patient_id', 'tarif_consultation_id'].every(key => Number.isInteger(Number(selected[key])) && Number(selected[key]) > 0)) throw Error('Sélection invalide')
            // Signed credential is deliberately kept out of component state and Vuex.
            const api = selected.source_tableau_sage_femme ? sageFemmeApi : store_consultation
            const credential = await api.getTableauMedecinAccess()
            if (!credential.success || !credential.data || !credential.data.access_token) throw Error('Accès indisponible')
            const response = await api.ouvrirConsultationTableauMedecin({
                consultation_id: selected.consultation_id, patient_id: selected.patient_id,
                tarif_consultation_id: selected.tarif_consultation_id, access_token: credential.data.access_token
            })
            if (!response || Number(response.id) !== Number(selected.consultation_id) ||
                Number(response.patient_id) !== Number(selected.patient_id) || Number(response.is_end) === 1) throw Error('Consultation indisponible')
            return response
        },
        async charger_contexte() {
            const sequence = ++this.sequence_demarrage
            this.contexte_loading = true
            this.contexte_erreur = false
            this.err_message = ''
            try {
                const consultation = await this.lire_consultation_exacte()
                if (!this.visible || sequence !== this.sequence_demarrage) return
                if (Number(consultation.is_start) === 1) {
                    this.conflit = true
                    this.err_message = 'Cette consultation a déjà démarré. Fermez cette fenêtre et actualisez le tableau pour la continuer.'
                    return
                }
                this.consultation_debut = consultation
                const responses = await Promise.all([
                    this.$store.dispatch('getEvolutionIDInitiale'), store_fiche.getGroupedFicheConsultation()
                ])
                if (!this.visible || sequence !== this.sequence_demarrage) return
                const h0 = Number(responses[0])
                if (!Number.isInteger(h0) || h0 <= 0) throw Error('Consultation initiale indisponible')
                this.contexte = { consultation_id: Number(consultation.id), evolution_id: h0 }
                const tarif = consultation.tarif_consultation || {}
                const type = tarif.type_consultation || {}
                this.fiches_disponibles = (Array.isArray(responses[1]) ? responses[1] : []).filter(fiche =>
                    !Number(fiche.type_consultation_id) || Number(fiche.type_consultation_id) === Number(type.id))
                this.curr_fiche = Number(consultation.fiche_consultation_id) || 0
                await this.charger_fiche(sequence)
            } catch (error) {
                if (sequence === this.sequence_demarrage && this.visible) {
                    this.contexte_erreur = true
                    this.err_message = 'Impossible de préparer cette consultation. Vérifiez son accès, sa validité et son attribution, puis réessayez.'
                }
            } finally {
                if (sequence === this.sequence_demarrage) this.contexte_loading = false
            }
        },
        async charger_fiche(sequence) {
            const tarif = this.consultation_debut.tarif_consultation || {}
            const response = await store_fiche.getListeFicheConsultationSection({
                fiche_id: this.curr_fiche, user_id: this.user_id,
                consultation_id: this.selection.consultation_id, type_consultation_id: (tarif.type_consultation || {}).id
            })
            if (!this.visible || sequence !== this.sequence_demarrage) return
            const groupes = Array.isArray(response.groupe_section) ? response.groupe_section : []
            const initial = groupes.find(groupe => Number(groupe.groupe_id) === Number(this.contexte.evolution_id))
            this.sections_debut = initial && Array.isArray(initial.sections) ? initial.sections : []
            this.contexte = Object.assign({}, this.contexte, { fiche_id: Number(response.fiche_id) || 0 })
            this.curr_fiche = this.contexte.fiche_id
            this.nom_fiche = this.libelleFiche(response.fiche || '')
        },
        async changer_fiche() {
            if (this.save_loading || this.resultat_incertain || this.conflit) return
            const sequence = ++this.sequence_demarrage
            this.is_confirm = false
            this.confirmation = false
            this.contexte_loading = true
            this.contexte_erreur = false
            this.err_message = ''
            this.sections_debut = []
            try { await this.charger_fiche(sequence) }
            catch (error) {
                if (sequence === this.sequence_demarrage) {
                    this.contexte_erreur = true
                    this.err_message = 'Impossible de charger cette fiche. Réessayez.'
                }
            } finally { if (sequence === this.sequence_demarrage) this.contexte_loading = false }
        },
        confirmer() {
            if (!this.demarrage_disponible) return
            this.is_confirm = true
            this.confirmation = false
            this.err_message = ''
        },
        async confirmStart() {
            if (!this.demarrage_disponible || !this.is_confirm) return
            if (!this.confirmation) {
                this.err_message = 'Merci de confirmer le démarrage de cette consultation.'
                return
            }
            this.err_message = ''
            const contexte = this.mode_tableau ? this.contexte : this.info_consultation
            const data = {
                fiche_id: contexte.fiche_id, user_id: this.user_id, user_info: this.user_info,
                consultation_id: contexte.consultation_id, evolution_id: contexte.evolution_id,
                sections: this.mode_tableau ? this.sections_debut : this.sections
            }
            this.save_loading = true
            const sequence = this.sequence_demarrage
            try {
                const response = await store_fiche.startConsultation(data)
                if (this._isDestroyed || sequence !== this.sequence_demarrage) return
                if (response.success) this.demarrage_reussi(response.message)
                else this.err_message = response.message || 'Le démarrage a été refusé.'
            } catch (error) {
                if (this._isDestroyed || sequence !== this.sequence_demarrage) return
                this.confirmation = false
                if (error && error.response && error.response.status === 409) {
                    const response_data = error.response.data || {}
                    this.conflit = true
                    const message = typeof response_data.message === 'string' && response_data.message.trim()
                        ? response_data.message : 'La consultation a changé ou a déjà démarré.'
                    this.err_message = message + ' Revenez au tableau de bord et actualisez la liste avant de réessayer.'
                } else {
                    this.resultat_incertain = true
                    this.err_message = 'Le résultat du démarrage n’a pas pu être confirmé. Vérifiez son état avant toute nouvelle tentative.'
                }
            } finally { this.save_loading = false }
        },
        async verifier_etat() {
            if (this.save_loading) return
            this.save_loading = true
            const sequence = this.sequence_demarrage
            try {
                const consultation = await this.lire_consultation_exacte()
                if (this._isDestroyed || sequence !== this.sequence_demarrage) return
                if (Number(consultation.is_start) === 1 && Number(consultation.medecin_id) === Number(this.user_id)) {
                    this.demarrage_reussi('Le démarrage de la consultation est confirmé.')
                } else if (Number(consultation.is_start) === 0) {
                    this.resultat_incertain = false
                    this.is_confirm = false
                    this.confirmation = false
                    this.err_message = 'Aucun démarrage constaté. Vérifiez la fiche puis confirmez à nouveau si nécessaire.'
                } else { this.err_message = 'Cette consultation a changé. Fermez cette fenêtre et actualisez le tableau.' }
            } catch (error) {
                if (!this._isDestroyed && sequence === this.sequence_demarrage) this.err_message = 'Vérification indisponible. Aucun nouvel envoi effectué. Réessayez la vérification ou revenez au tableau.'
            }
            finally { this.save_loading = false }
        },
        demarrage_reussi(message) {
            this.visible = false
            if (typeof window !== 'undefined' && typeof CustomEvent === 'function') window.dispatchEvent(new CustomEvent('clinicaa:consultation-updated'))
            this.successToast(message || 'Consultation démarrée avec succès.')
            if (this.mode_tableau) this.$emit('demarree', Object.assign({}, this.selection))
            else this.$emit('emitRefreshConsultation')
        }
    }
}
